// Ruta de un objeto en Storage a partir del valor guardado en la base (Fase 0,
// bloque 10). Sin dependencias: lo usan lib/archivos.ts y lib/sso-documentos.ts.
export type BucketArchivos = 'sso-documents' | 'safety-sheets' | 'layout-files' | 'incident-files';

/**
 * - URL que contiene `/<bucket>/` (la pública de getPublicUrl, o una firmada):
 *   lo que sigue, decodificado (getPublicUrl aplica encodeURI) y sin ?… ni #….
 *   Si trae un % suelto que no se puede decodificar, se deja tal cual.
 * - Valor que no es URL: es la ruta tal cual (así se guarda desde M30).
 * - URL de otro bucket, o vacío: null.
 */
export function rutaEnBucket(bucket: BucketArchivos, valor: string | null | undefined): string | null {
  const v = (valor ?? '').trim();
  if (!v) return null;
  if (!/^https?:\/\//i.test(v)) return v.replace(/^\/+/, '') || null;
  const marker = `/${bucket}/`;
  const idx = v.indexOf(marker);
  if (idx === -1) return null;
  const cruda = v.slice(idx + marker.length).split(/[?#]/)[0];
  if (!cruda) return null;
  try {
    return decodeURIComponent(cruda);
  } catch {
    return cruda;
  }
}
